/* eslint-disable react/prop-types */
import ArticleIcon from "@mui/icons-material/Article";
import AssignmentIcon from "@mui/icons-material/Assignment";
import AutoFixHighIcon from "@mui/icons-material/AutoFixHigh";
import BusinessIcon from "@mui/icons-material/Business";
import Diversity2Icon from "@mui/icons-material/Diversity2";
import EmojiEmotionsIcon from "@mui/icons-material/EmojiEmotions";
import InfoIcon from "@mui/icons-material/Info";
import LocalGroceryStoreIcon from "@mui/icons-material/LocalGroceryStore";
import LocalLibraryIcon from "@mui/icons-material/LocalLibrary";
import PlaylistAddCheckCircleIcon from "@mui/icons-material/PlaylistAddCheckCircle";
import PreviewIcon from "@mui/icons-material/Preview";
import PublicIcon from "@mui/icons-material/Public";
import ReceiptLongIcon from "@mui/icons-material/ReceiptLong";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import SafetyCheckIcon from "@mui/icons-material/SafetyCheck";
import SaveIcon from "@mui/icons-material/Save";
import SendIcon from "@mui/icons-material/Send";
import VerifiedIcon from "@mui/icons-material/Verified";
import CustomTabPanel from "components/CustomPanel/customPanel";
import { DownloadIcon } from "@primer/octicons-react";
import {
  Box,
  Button,
  Grid,
  Pagination,
  Step,
  StepConnector,
  StepLabel,
  Stepper,
  Tab,
  Tabs,
  Typography,
  Link,
} from "@mui/material";
import { stepConnectorClasses } from "@mui/material/StepConnector";
import { styled } from "@mui/material/styles";
import AddListFile from "components/AddListFile";
import DialogProgress from "components/CircularProgressWithLabel/dialogProgress";
import Footer from "components/Footer";
import DashboardLayout from "components/LayoutContainers/DashboardLayout";
import LoadingCircle from "components/LoadingCircle/loadingCircle";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import DashboardNavbar from "components/Navbars/DashboardNavbar";
import Textarea from "components/Textarea";
import dayjs from "dayjs";
import useAuth from "hooks/useAuth";
import useAxiosPrivateForm from "hooks/useAxiosPrivateForm";
import { Fragment, useEffect, useMemo, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { AlertState, DicBoTieuChiState, SettingState } from "states";
import { JsonTool } from "utils/jsonTools";
import useAxiosPrivate from "../../hooks/useAxiosPrivate";
import { useQuery } from "../../hooks/useQuery";
import {
  API_ROUTES,
  API_ROUTES_V2,
  checkGroupUser,
  ID_GROUP_CAPTINH,
  ID_GROUP_HOIDONG,
  ID_GROUP_NUMBER_ONE,
  ID_GROUP_NUMBER_SEVEN,
  ID_GROUP_PHUONGXA,
  PermissionMenuKey,
  validateArrayFileRequired,
  API_URL_DOWNLOAD,
  checkUrlTep,
} from "../../utils/constants";
import PublishedWithChangesIcon from "@mui/icons-material/PublishedWithChanges";

const ColorlibConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 16,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        "linear-gradient( 95deg,#0c3483 0%,#a2b6df 50%,#6b8cce 100%)",
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      backgroundImage:
        "linear-gradient( 95deg,#0c3483 0%,#a2b6df 50%,#6b8cce 100%)",
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor:
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0",
    borderRadius: 1,
  },
}));

const ColorlibStepIconRoot = styled("div")(({ theme, ownerState }) => ({
  backgroundColor:
    theme.palette.mode === "dark" ? theme.palette.grey[700] : "#ccc",
  zIndex: 1,
  color: "#fff",
  width: 36,
  height: 36,
  display: "flex",
  borderRadius: "50%",
  justifyContent: "center",
  alignItems: "center",
  ...(ownerState.active && {
    backgroundImage: "linear-gradient(to right, #586ee5 0%, #001fb0 100%)",
    boxShadow: "0 4px 10px 0 rgba(0,0,0,.25)",
  }),
  ...(ownerState.completed && {
    backgroundImage: "linear-gradient(to right, #586ee5 0%, #001fb0 100%)",
  }),
}));

const ColorlibStepIcon = (iconNumber) => (props) => {
  const { active, completed, className } = props;

  const icons = {
    1: <Diversity2Icon />,
    2: <RocketLaunchIcon />,
    3: <EmojiEmotionsIcon />,
    4: <LocalGroceryStoreIcon />,
    5: <LocalLibraryIcon />,
    6: <PreviewIcon />,
    7: <AutoFixHighIcon />,
    8: <PlaylistAddCheckCircleIcon />,
    9: <VerifiedIcon />,
    10: <PublicIcon />,
    11: <SafetyCheckIcon />,
    12: <ReceiptLongIcon />,
  };

  return (
    <ColorlibStepIconRoot
      ownerState={{ completed, active }}
      className={className}
    >
      {icons[String(iconNumber)] ? icons[String(iconNumber)] : <InfoIcon />}
    </ColorlibStepIconRoot>
  );
};
function FormChamDiemCapTinh() {
  const { id, status, thanhvien } = useQuery();
  const { user } = useAuth();
  const navigate = useNavigate();
  const axiosPrivateInstance = useAxiosPrivate();
  const axiosForm = useAxiosPrivateForm();
  const setAlert = useSetRecoilState(AlertState);
  const [sanPham, setSanPham] = useState(); //state thông tin sản phẩm đăng ký
  const [isLoading, setIsLoading] = useState(false); //loading data
  const [activeStep, setActiveStep] = useState({
    //các step theo từng tab
    0: 0,
    1: 0,
    2: 0,
  });
  const [dataBoTieuChi, setBoTieuChi] = useState([]); // danh sách bộ tiêu chí đã chia nhóm -nhóm bộ
  const [dataChamDiem, setDataChamDiem] = useState(); //lấy hồ sơ chấm điểm trả về thông tin các điểm đã chấm trước đó
  const [dataChamDiemHoiDongCapHuyen, setDataChamDiemHoiDongCapHuyen] =
    useState(); //lấy hồ sơ chấm điểm hội đồng cấp huyện
  const [showYKien, setShowYKien] = useState(false); //state filed ý kiến đánh giá
  const listBoTieuChiNhom = useRecoilValue(DicBoTieuChiState); //danh sách bộ tiêu chí chứa nhombotieuchi_id để kiểm tra 1 nhombotieuchi chỉ có thể có 1 tiêu chí được chọn
  const [pageQuestion, setPageQuestion] = useState({
    //state page theo tab - step => tab[step] = page
    0: {},
    1: {},
    2: {},
  });

  //
  const [tab, setTab] = useState(0);
  const [tabSanPham, setTabSanPham] = useState(0);
  const [steps, setSteps] = useState([]); //danh sách các steps của 1 tab
  const settingState = useRecoilValue(SettingState);
  //state file
  const [fileDel, setFileDel] = useState([]);
  const [fileFields, setFileFields] = useState([]);
  const [fileEditName, setFileEditName] = useState({});
  const [errors, setErrors] = useState({});

  //progress
  const _openDialog = useRef(false);
  const [openLoadingDialog, setOpenLoadingDialog] = useState(false);
  const [valueProgress, setValueProgress] = useState(0);

  //kiểm tra đang đăng nhập với nhóm hội đồng = 6
  const isHoiDong = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_HOIDONG);
  }, [user]);

  //Kiểm tra nhóm người dùng là 1
  const isGroupNumberOne = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_NUMBER_ONE);
  }, [user]);
  //kiểm tra nhóm người dùng là 9 - cấp tỉnh
  const isGroupNumberNine = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_CAPTINH);
  }, [user]);
  //kiểm tra nhóm người dùng là 7
  const isGroupNumberSeven = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_NUMBER_SEVEN);
  }, [user]);
  //kiểm tra nhóm người dùng là 8 - phường/xã
  const isGroupNumberEight = useMemo(() => {
    return checkGroupUser(user, ID_GROUP_PHUONGXA);
  }, [user]);

  useEffect(() => {
    if (status == 2 && sanPham && sanPham.id && sanPham.sanpham_ten) {
      setAlert({
        alert: true,
        message: (
          <p>
            Phiếu đăng ký sản phẩm{" "}
            <span style={{ color: "red", fontWeight: "bolder" }}>
              {sanPham.sanpham_ten}
            </span>{" "}
            của bạn đã chấm xong !
          </p>
        ),
        type: "info",
      });
    }
  }, [status, sanPham]);

  useEffect(() => {
    return () => {
      setFileDel([]);
      setFileFields([]);
      setFileEditName({});
    };
  }, []);

  useEffect(() => {
    const fetchDataDangKySanPham = (id, thanhvien, listNhomTieuChi) => {
      setIsLoading(true);
      axiosPrivateInstance
        .get(API_ROUTES_V2.PHIEUDANGKY + "/" + id)
        .then((response) => {
          const data = response.data;
          setSanPham(data);
          setDataChamDiemHoiDongCapHuyen(data.hoidong_caphuyen);
          if (data) {
            if (data.nhomsanpham_id) {
              axiosPrivateInstance
                .get(API_ROUTES.BOTIEUCHI, {
                  params: {
                    nhomsanpham: data.nhomsanpham_id,
                    nhom: true,
                  },
                })
                .then((res1) => {
                  const data = res1.data[0]?.nhom;
                  //bỏ rỗng
                  const nhomNoEmpty = data?.filter(
                    (nhom) =>
                      !nhom?.nhombotieuchi?.every(
                        (tieuchi) => tieuchi?.botieuchi?.length === 0
                      )
                  );
                  setBoTieuChi(nhomNoEmpty);
                  //tạo dic cho phân trang
                  let dicPageValues = { 0: {}, 1: {}, 2: {} };
                  const indexTabs = [0, 1, 2];
                  indexTabs.forEach((index) => {
                    const nhomBoTieuChi =
                      nhomNoEmpty?.filter((nhom) => nhom?.nhom == index + 1) ||
                      [];
                    nhomBoTieuChi?.forEach((nhomBo, idx) => {
                      //tab, step => page
                      dicPageValues[String(index)][String(idx)] = 1;
                    });
                  });
                  setPageQuestion(dicPageValues);
                  //data ban đầu của steps với tạo mới ban đầu là tab =0 có nhom=1
                  const dataStep = nhomNoEmpty?.filter((item) => {
                    if (item?.nhom == 1)
                      return {
                        id: item?.id,
                        ten: item?.ten,
                        diem: item?.diem || 0,
                      };
                  });
                  if (dataStep && dataStep.length > 0) {
                    setSteps(dataStep);
                  }
                });
            }
            if (
              data.chamdiem &&
              listNhomTieuChi &&
              Object.values(listNhomTieuChi).length > 0
            ) {
              axiosPrivateInstance
                .get(API_ROUTES.GETHOSOCHAMDIEMCAPTINH, {
                  params: {
                    chamdiem: data.chamdiem[0]?.id,
                    thanhvien: thanhvien,
                  },
                })
                .then((res) => {
                  const listDataDiem = res.data?.data[0];
                  let dicDiem = {};
                  //thêm nhombotieuchi_id cho hồ sơ chấm điểm
                  listDataDiem?.botieuchi?.forEach(
                    (item) =>
                      (dicDiem[item?.botieuchi] = {
                        ...item,
                        nhomtieuchi_id:
                          listNhomTieuChi[item?.botieuchi]?.nhombotieuchi_id,
                      })
                  );
                  setDataChamDiem({
                    ...listDataDiem,
                    botieuchi: dicDiem,
                  });
                });
            }
          }
        })
        .catch((error) => {
          setAlert({
            alert: true,
            message: error?.message || "Lỗi!",
            type: "error",
          });
        })
        .finally(() => {
          setIsLoading(false);
        });
    };
    if (
      id &&
      listBoTieuChiNhom &&
      Object.values(listBoTieuChiNhom).length > 0
    ) {
      if (thanhvien) {
        fetchDataDangKySanPham(id, thanhvien, listBoTieuChiNhom);
      } else {
        if (user && user?.id) {
          fetchDataDangKySanPham(id, user?.thanhvien, listBoTieuChiNhom);
        }
      }
    }
    return () => {
      setSanPham(null);
    };
  }, [id, user, listBoTieuChiNhom, thanhvien]);

  //các trường thông tin của form đăng ký sản phẩm cần đánh giá
  const dataInfor = useMemo(() => {
    const result = [
      {
        key: "nhomsanpham_ten",
        name: "Bộ sản phẩm",
      },
      {
        key: "phanloai_ten",
        name: "Nhóm sản phẩm",
      },
      {
        key: "sanpham_ten",
        name: "Tên sản phẩm",
      },
      {
        key: "sanpham_ma",
        name: "Mã số sản phẩm",
      },
      {
        key: "chuthe_ten",
        name: "Tên chủ thể sản xuất",
      },
      {
        key: "dienthoai",
        name: "Điện thoại",
      },
      {
        key: "diachi",
        name: "Địa chỉ",
      },
    ];
    return result;
  }, []);
  const dataContent = useMemo(() => {
    const result = [
      {
        key: "noidung_nguongoc",
        name: "Sử dụng nguyên liệu địa phương:",
      },
      {
        key: "noidung_laodong",
        name: "Sử dụng lao động địa phương:",
      },
      {
        key: "noidung_ytuong",
        name: "Nguồn gốc ý tưởng sản phẩm:",
      },
      {
        key: "noidung_bansac",
        name: "Bản sắc/Trí tuệ địa phương:",
      },
      {
        key: "noidung_khac",
        name: "Nội dung khác:",
      },
    ];
    return result;
  }, []);
  const handleNext = () => {
    //bấm nút tiếp theo của steps
    let newTab = tab;
    let newTabStep = activeStep[tab] + 1;
    if (tab == 2 && activeStep[2] == steps.length - 1) {
      //khi ở step cuối cùng của tab cuối
      newTabStep = activeStep[tab];
      setShowYKien(true);
    } else if (activeStep[tab] == steps?.length - 1) {
      //có xuất hiện step tiếp theo hoặc tab tiếp theo
      showYKien && setShowYKien(false);
      newTab = tab + 1;
      const dataStep = dataBoTieuChi?.filter((item) => {
        if (item?.nhom == newTab + 1) return { id: item?.id, ten: item?.ten };
      });
      setSteps(dataStep);
      newTabStep = 0;
      setTab(newTab);
    }
    setActiveStep((prevActiveStep) => ({
      ...prevActiveStep,
      [newTab]: newTabStep,
    }));
  };

  const handleBack = () => {
    //trở về steps kế trước hoặc nếu ở vị trí index =0 của  steps thì trở về step cuối của tab trước đó
    let newTab = tab;
    let newTabStep = activeStep[tab] - 1;
    if (activeStep[tab] == 0) {
      //khi tab là ở step index = 0 thì trở về step cuối cùng tab trước
      newTab = tab - 1;
      const dataStep = dataBoTieuChi?.filter((item) => {
        if (item?.nhom == newTab + 1) return { id: item?.id, ten: item?.ten };
      });
      setSteps(dataStep);
      newTabStep = dataStep?.length - 1;
      setTab(newTab);
    }
    setActiveStep((prevActiveStep) => ({
      ...prevActiveStep,
      [newTab]: newTabStep,
    }));
  };

  const handleReset = () => {
    //khi ở nội dung ý kiến đánh giá trở về phía step cuối của tạp cuối
    setActiveStep((prev) => ({
      ...prev,
      2: steps.length - 1,
    }));
    setShowYKien(false); // ẩn form ý kiến đi
  };

  const handleChangePage = (e, page) => {
    // thay đổi câu hỏi và trả lời trong step, tab hiện tại
    setPageQuestion((prev) => ({
      ...prev,
      [tab]: {
        ...prev[tab],
        [activeStep[tab]]: page,
      },
    }));
  };

  const handleToClickTieuChi = (item, idNhom) => (e) => {
    //nếu đã có tiêu chí cho nhóm tiêu chí rồi thì xóa rồi ms thực hiện thêm tiêu chí mới
    if (item && item.id && status !== 2 && idNhom) {
      setDataChamDiem((prev) => {
        let newBoTieuChi = { ...prev?.botieuchi };
        Object.keys(newBoTieuChi).forEach((key) => {
          if (newBoTieuChi[key].nhomtieuchi_id === idNhom) {
            delete newBoTieuChi[key]; //xóa
          }
        });
        newBoTieuChi[item.id] = {
          //thêm
          ...item,
          botieuchi: item.id,
          nhomtieuchi_id: idNhom,
        };
        return {
          ...prev,
          botieuchi: newBoTieuChi,
        };
      });
    }
  };
  const handleChangeTabSanPham = (event, newValue) => {
    setTabSanPham(newValue);
  };
  const handleChangeTab = (event, newValue) => {
    setTab(newValue);
    const dataStep = dataBoTieuChi?.filter((item) => {
      if (item?.nhom == newValue + 1) return { id: item?.id, ten: item?.ten };
    }); //thay đổi danh sách steps
    setSteps(dataStep);
    showYKien && setShowYKien(false); //nếu đang show form ý kiến thì ẩn đi
  };
  const listNhomTieuChi = useMemo(() => {
    // danh sách các câu hỏi thuộc step đang active
    const list = dataBoTieuChi
      ?.filter((item) => item?.nhom == tab + 1)
      ?.[activeStep[tab]]?.nhombotieuchi?.filter(
        (nhom) => nhom?.botieuchi?.length > 0
      );
    return list;
  }, [dataBoTieuChi, activeStep, tab]);

  const nhomBoTieuChi = useMemo(() => {
    // câu hỏi đươc chọn show lên theo dicPage đã lập dạng dict[tabActive][stepActive] = pageActive
    const idx = pageQuestion[tab]?.[activeStep[tab]] - 1;
    const list = listNhomTieuChi?.[idx];
    return list;
  }, [listNhomTieuChi, pageQuestion, activeStep, tab]);

  const handleChangeYKien = (e) => {
    const { value } = e.target;
    setDataChamDiem((prev) => ({
      ...prev,
      ykiendanhgia: value,
    }));
  };
  const totalPoint = useMemo(() => {
    //lấy tất cả điểm đã chấm ra tính tổng
    let totalScore = 0;
    if (dataChamDiem && dataChamDiem.botieuchi) {
      Object.values(dataChamDiem.botieuchi).forEach((item) => {
        if (item && item.diem) {
          totalScore += item?.diem;
        }
      });
    }
    return totalScore;
  }, [dataChamDiem]);

  const getDataToPut = async () => {
    // tổng hợp data cần thực hiện put
    let _data = {
      phieudangky: sanPham?.id,
      hoidong: sanPham?.chamdiem[0]?.hoidong_id,
      tongdiem: totalPoint,
      ngaycham: dayjs(new Date()).format("YYYY-MM-DD"),
      botieuchi: Object.values(dataChamDiem?.botieuchi)?.map(
        (item) => item?.botieuchi
      ),
      chamdiem: sanPham?.chamdiem?.[0]?.id,
      thanhvien: thanhvien ? thanhvien : user?.thanhvien,
      ykiendanhgia: dataChamDiem?.ykiendanhgia,
    };
    _data["dulieu_ok"] = false;
    _data["fileDel"] = fileDel;
    _data["tentepdinhkem"] = fileFields?.map((item) => item?.filename) || [];
    _data["tepdinhkemValidate"] = fileFields?.map((item) => item?.file) || [];
    _data["tentepdinhkemEdit"] = Object.values(fileEditName);
    const newValidationErrors = validateOBJ(
      _data,
      settingState["dungluong_file_upload"]
    );
    let _tempValid = newValidationErrors;
    if (
      _tempValid["tepdinhkemValidate"] &&
      _tempValid["tepdinhkemValidate"].some((error) => error)
    ) {
      setErrors(newValidationErrors);
      return _data;
    }
    if (
      _tempValid["tentepdinhkem"] &&
      _tempValid["tentepdinhkem"].some((error) => error)
    ) {
      setErrors(newValidationErrors);
      return _data;
    }

    if (
      _tempValid["tentepdinhkemEdit"] &&
      Object.values(_tempValid["tentepdinhkemEdit"])?.length > 0 &&
      Object.values(_tempValid["tentepdinhkemEdit"]).some((error) => error)
    ) {
      setErrors(newValidationErrors);
      return _data;
    }

    delete _tempValid["tentepdinhkem"];
    delete _tempValid["tepdinhkemValidate"];
    delete _tempValid["tentepdinhkemEdit"];
    delete _data["tepdinhkemValidate"];
    if (Object.values(_tempValid).some((error) => error)) {
      setErrors((prev) => ({
        ...prev,
        ...newValidationErrors,
      }));
      return _data;
    }
    let listName = [];
    fileFields?.forEach((item) => {
      if (!item?.remove) {
        listName.push(item?.filename);
      }
    });
    _data["tentepdinhkem"] = listName;
    _data["tepdinhkem"] = fileFields?.map((item) => item?.file) || [];
    _data["dulieu_ok"] = true;
    return _data;
  };

  //khi post, put data tính progress complete
  const configCircularProgressWithLabel = {
    onUploadProgress: function (progressEvent) {
      !openLoadingDialog && !_openDialog.current && setOpenLoadingDialog(true);
      const percentCompleted = Math.round(
        (progressEvent.loaded * 100) / progressEvent.total
      );
      setValueProgress(percentCompleted);
    },
  };
  const handleToPutData = (mess) => {
    setAlert({
      alert: true,
      message: mess,
      type: "success",
    });
    let toLink = `/chamdiemcaptinh/${
      PermissionMenuKey.hosodangkycaptinh
    }?trangthai=1&nam=${new Date().getFullYear()}`; // chuyển về danh sách đăng sản phẩm OCOP chưa hoàn thành đánh giá
    if (thanhvien) {
      toLink = `/chamdiemcaptinh/${PermissionMenuKey.ocopcaptinh}`;
    }
    navigate(toLink);
  };
  const handleToSendDataSuccess = (isUpload, mess) => {
    if (isUpload) {
      setValueProgress(100);
      setTimeout(() => {
        setOpenLoadingDialog(false);
        handleToPutData(mess);
      }, [400]);
    } else {
      handleToPutData(mess);
    }
  };
  const onClickSave = async () => {
    if (_openDialog.current) {
      _openDialog.current = false;
    }
    //chỉ lưu thông tin để lần sau làm tiếp
    const values = await getDataToPut();
    if (values?.dulieu_ok === false) return;
    const idChamDiem = dataChamDiem?.id;
    const isHasUploadFile = values?.tepdinhkem?.length > 0;
    let config = {};
    if (isHasUploadFile) {
      config = { ...configCircularProgressWithLabel };
    }
    if (idChamDiem) {
      axiosForm
        .put(
          API_ROUTES.HOIDONGCHAMDIEMCAPTINH + "/" + dataChamDiem?.id,
          {
            ...values,
            trangthai: 1,
          },
          { ...config }
        )
        .then((res) => {
          if (res?.data) {
            handleToSendDataSuccess(
              isHasUploadFile,
              "Lưu phiếu chấm điểm thành công!"
            );
          }
        })
        .catch((error) => {
          if (isHasUploadFile) {
            _openDialog.current = true;
            setOpenLoadingDialog(false);
          }
          setAlert({
            alert: true,
            message: error?.message || "Lỗi!",
            type: "error",
          });
          return;
        })
        .finally(() => {
          if (isHasUploadFile) {
            _openDialog.current = true;
            setOpenLoadingDialog(false);
          }
        });
    } else {
      axiosForm
        .post(
          API_ROUTES.HOIDONGCHAMDIEMCAPTINH,
          {
            ...values,
            trangthai: 1,
          },
          { ...config }
        )
        .then((res) => {
          if (res?.data) {
            handleToSendDataSuccess(
              isHasUploadFile,
              "Lưu phiếu chấm điểm thành công!"
            );
          }
        })
        .catch((error) => {
          if (isHasUploadFile) {
            _openDialog.current = true;
            setOpenLoadingDialog(false);
          }
          setAlert({
            alert: true,
            message: error?.message || "Lỗi!",
            type: "error",
          });
          return;
        })
        .finally(() => {
          if (isHasUploadFile) {
            _openDialog.current = true;
            setOpenLoadingDialog(false);
          }
        });
    }
  };

  const onClickSend = async () => {
    if (_openDialog.current) {
      _openDialog.current = false;
    }
    //đã hoàn thành form
    const values = await getDataToPut();
    if (values?.dulieu_ok === false) return;
    const idChamDiem = dataChamDiem?.id;
    const isHasUploadFile = values?.tepdinhkem?.length > 0;
    let config = {};
    if (isHasUploadFile) {
      config = { ...configCircularProgressWithLabel };
    }
    if (idChamDiem) {
      axiosForm
        .put(
          API_ROUTES.HOIDONGCHAMDIEMCAPTINH + "/" + dataChamDiem?.id,
          {
            ...values,
            trangthai: 2,
          },
          { ...config }
        )
        .then((res) => {
          if (res?.data) {
            handleToSendDataSuccess(
              isHasUploadFile,
              "Gửi phiếu chấm điểm thành công!"
            );
          }
        })
        .catch((error) => {
          if (isHasUploadFile) {
            _openDialog.current = true;
            setOpenLoadingDialog(false);
          }
          setAlert({
            alert: true,
            message: error?.message || "Lỗi!",
            type: "error",
          });
          return;
        })
        .finally(() => {
          if (isHasUploadFile) {
            _openDialog.current = true;
            setOpenLoadingDialog(false);
          }
        });
    } else {
      axiosForm
        .post(
          API_ROUTES.HOIDONGCHAMDIEMCAPTINH,
          {
            ...values,
            trangthai: 2,
          },
          { ...config }
        )
        .then((res) => {
          if (res?.data) {
            handleToSendDataSuccess(
              isHasUploadFile,
              "Gửi phiếu chấm điểm thành công!"
            );
          }
        })
        .catch((error) => {
          if (isHasUploadFile) {
            _openDialog.current = true;
            setOpenLoadingDialog(false);
          }
          setAlert({
            alert: true,
            message: error?.response?.[0] || error?.message || "Lỗi!",
            type: "error",
          });
          return;
        })
        .finally(() => {
          if (isHasUploadFile) {
            _openDialog.current = true;
            setOpenLoadingDialog(false);
          }
        });
    }
  };

  const handleErrorDownload = (error) => {
    setAlert({
      alert: true,
      message: error,
      type: "error",
    });
  };
  //change file
  const handleErrorDownloadFile = (error) => {
    setAlert(error);
  };
  const handleOnDeleteFileDefault = (data) => {
    setFileDel(data);
  };
  const handleErrorFile = (error) => {
    setErrors(error);
  };
  const handleChangeFileList = (data) => {
    setFileFields(data);
  };
  const handleEditFileNameDefault = (data) => {
    setFileEditName(data);
  };
  //handle Steps
  const handleStepClick = (stepIndex) => () => {
    setActiveStep((prev) => ({
      ...prev,
      [tab]: stepIndex,
    }));
  };
  return (
    <DashboardLayout>
      <DashboardNavbar />
      {isLoading ? (
        <div className="w-full flex items-center justify-center mt-12">
          <LoadingCircle size={46} />
        </div>
      ) : (
        <>
          <MDBox
            sx={{
              width: "100%",
              bgcolor: "background.paper",
              marginTop: "0.5rem",
              borderColor: "divider",
              padding: "0.5rem 1rem",
              borderRadius: "0.5rem",
            }}
          >
            <Tabs
              value={tabSanPham}
              onChange={handleChangeTabSanPham}
              indicatorColor="secondary"
              textColor="primary"
              variant="fullWidth"
              centered
            >
              <Tab
                icon={<BusinessIcon />}
                label="THÔNG TIN SẢN PHẨM"
                {...JsonTool.a11yProps(0)}
                wrapped
              />
              <Tab
                icon={<ArticleIcon />}
                label="TỆP ĐÍNH KÈM"
                {...JsonTool.a11yProps(1)}
              />
              {(isHoiDong ||
                isGroupNumberNine ||
                isGroupNumberOne ||
                isGroupNumberSeven ||
                isGroupNumberEight) && (
                <Tab
                  icon={<AssignmentIcon />}
                  label="NỘI DUNG BÁO CÁO CẤP XÃ"
                  {...JsonTool.a11yProps(2)}
                />
              )}
              {(isHoiDong || isGroupNumberNine || isGroupNumberOne) && (
                <Tab
                  icon={<PublishedWithChangesIcon />}
                  label="ĐÁNH GIÁ TỪ CẤP HUYỆN"
                  {...JsonTool.a11yProps(3)}
                />
              )}
            </Tabs>
            <CustomTabPanel value={tabSanPham} index={0}>
              <Grid container spacing={1}>
                {dataInfor.map((item, index) => (
                  <Fragment key={item?.key + index + "inforchamdiem"}>
                    <Grid item xs={12} md={3} lg={2}>
                      <Typography fontSize={"0.85rem"}>{item?.name}</Typography>
                    </Grid>
                    <Grid item xs={12} md={9} lg={4}>
                      <Typography fontSize={"1rem"} fontWeight={700}>
                        {sanPham?.[item?.key]
                          ? sanPham?.[item?.key]
                          : "Đang cập nhập..."}
                      </Typography>
                    </Grid>
                  </Fragment>
                ))}
              </Grid>
            </CustomTabPanel>
            <CustomTabPanel value={tabSanPham} index={1}>
              <Grid item xs={12}>
                {sanPham?.tepdinhkem_phieudangky &&
                sanPham?.tepdinhkem_phieudangky?.length > 0 ? (
                  <Grid container p="0 1rem 1rem 1rem">
                    <Grid
                      container
                      style={{
                        color: "#000000",
                        backgroundColor: "#c6e3fa",
                      }}
                      fontSize={"1rem"}
                      fontWeight={600}
                      pb={"0.5rem"}
                      m={"0.5rem 0"}
                      spacing={1}
                      borderBottom={"2px solid #3F51B5"}
                    >
                      <Grid item xs={2}>
                        STT
                      </Grid>
                      <Grid item xs={8}>
                        Tên tệp đính kèm
                      </Grid>
                      <Grid item xs={2}>
                        Tải về
                      </Grid>
                    </Grid>
                    {sanPham?.tepdinhkem_phieudangky?.map((tep, index) => (
                      <Grid
                        container
                        key={tep?.id + index + "tepdinhkem"}
                        style={{ color: "#000000" }}
                        fontSize={"1rem"}
                        borderBottom={"1px solid #d6d6d6"}
                        pb={"0.5rem"}
                        mb={"0.5rem"}
                        ml={0}
                        spacing={1}
                      >
                        <Grid item xs={2}>
                          {index + 1}
                        </Grid>
                        <Grid item xs={8}>
                          {tep?.tentepdinhkem}
                        </Grid>
                        <Grid
                          item
                          xs={2}
                          display={"flex"}
                          alignItems={"center"}
                          justifyContent={"center"}
                          style={{ paddingTop: "0px" }}
                        >
                          <Typography variant="h5" color="info">
                            <Link
                              target="_blank"
                              href={
                                API_URL_DOWNLOAD + checkUrlTep(tep?.tepdinhkem)
                              }
                            >
                              <DownloadIcon />
                            </Link>
                          </Typography>
                        </Grid>
                      </Grid>
                    ))}
                  </Grid>
                ) : (
                  <Grid
                    container
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                    p="1rem"
                    height="100%"
                  >
                    <Typography
                      style={{
                        fontSize: "1.25rem",
                        fontWeight: "500",
                        lineHeight: "1.5rem",
                        color: "black",
                      }}
                    >
                      Không có thông tin Tệp đính kèm
                    </Typography>
                  </Grid>
                )}
              </Grid>
            </CustomTabPanel>
            <CustomTabPanel value={tabSanPham} index={2}>
              <Grid container spacing={1}>
                {dataContent.map((item, index) => (
                  <Fragment key={item?.key + index + "inforchamdiem"}>
                    <Grid item xs={12} md={3} lg={3}>
                      <Typography fontSize={"0.85rem"}>{item?.name}</Typography>
                    </Grid>
                    <Grid item xs={12} md={9} lg={9}>
                      <Typography fontSize={"1rem"} fontWeight={700}>
                        {sanPham?.[item?.key]
                          ? sanPham?.[item?.key]
                          : "Đang cập nhập..."}
                      </Typography>
                    </Grid>
                  </Fragment>
                ))}
              </Grid>
            </CustomTabPanel>
            <CustomTabPanel value={tabSanPham} index={3}>
              <Grid
                container
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexDirection: "column",
                  gap: "0.5rem",
                }}
                p="1rem"
                height="100%"
              >
                {sanPham?.chamdiem && sanPham?.chamdiem?.length > 0 ? (
                  <>
                    <Typography
                      style={{
                        fontSize: "1.25rem",
                        fontWeight: "500",
                        lineHeight: "1.5rem",
                        color: "black",
                      }}
                    >
                      {dayjs(dataChamDiemHoiDongCapHuyen[0].ngaycham).isValid()
                        ? dayjs(dataChamDiemHoiDongCapHuyen[0].ngaycham).format(
                            "DD/MM/YYYY"
                          )
                        : dataChamDiemHoiDongCapHuyen[0].ngaycham}
                    </Typography>
                    <Typography
                      style={{
                        fontSize: "1.25rem",
                        fontWeight: "500",
                        lineHeight: "1.5rem",
                        color: "black",
                      }}
                    >
                      Tổng số điểm: {dataChamDiemHoiDongCapHuyen[0].tongdiem}{" "}
                      điểm
                    </Typography>
                  </>
                ) : (
                  <Typography
                    style={{
                      fontSize: "1.25rem",
                      fontWeight: "500",
                      lineHeight: "1.5rem",
                      color: "black",
                    }}
                  >
                    Cấp huyện chưa chấm xong hoặc chưa tổng hợp điểm từ các
                    phiếu thành viên chấm!
                  </Typography>
                )}
              </Grid>
            </CustomTabPanel>
          </MDBox>
          <MDBox
            sx={{
              width: "100%",
              bgcolor: "background.paper",
              marginTop: "0.5rem",
              borderColor: "divider",
              padding: "0.5rem 1rem",
              borderRadius: "0.5rem",
            }}
          >
            <Tabs
              value={tab}
              onChange={handleChangeTab}
              indicatorColor="secondary"
              textColor="primary"
              variant="fullWidth"
              centered
            >
              <Tab
                // icon={<Diversity2Icon />}
                label="PHẦN A - SẢN PHẨM VÀ SỨC MẠNH CỦA CỘNG ĐỒNG (40 ĐIỂM)"
                {...JsonTool.a11yProps(0)}
                wrapped
              />
              <Tab
                // icon={<LocalGroceryStoreIcon />}
                label="PHẦN B - KHẢ NĂNG TIẾP THỊ (25 ĐIỂM)"
                {...JsonTool.a11yProps(1)}
              />
              <Tab
                // icon={<VerifiedIcon />}
                label="PHẦN C - CHẤT LƯỢNG SẢN PHẨM (35 ĐIỂM)"
                {...JsonTool.a11yProps(2)}
              />
            </Tabs>
          </MDBox>
          <MDBox
            sx={{
              height: "1rem",
              display: "flex",
              alignItems: "center",
              position: "relative",
            }}
            mt={2}
          >
            <div className="mr-4 text-lg">Tổng điểm: </div>
            <div className="relative flex-1 flex items-center">
              <div className="absolute bg-slate-200 w-full h-4 rounded-full"></div>
              <div
                className={`absolute h-4 rounded-full`}
                style={{
                  width: `${totalPoint > 100 ? 100 : totalPoint}%`,
                  transition: "width 1s",
                  backgroundImage:
                    "linear-gradient(to right, #586ee5 0%, #001fb0 100%)",
                }}
              ></div>
              <div
                className={`absolute left-[45%] text-sm ${
                  totalPoint > 45 ? "text-slate-400" : "text-slate-700"
                }`}
              >
                {totalPoint}/100
              </div>
            </div>
          </MDBox>
          {showYKien ? (
            <Grid
              container
              sx={{
                backgroundColor: "#fff",
                borderRadius: "0.5rem",
                padding: "0.75rem 1.5rem",
                marginTop: "0.5rem",
              }}
            >
              <Grid item xs={12}>
                <Typography sx={{ mt: 2, mb: 1 }}>Ý kiến đánh giá</Typography>
                <Box sx={{ flex: "1 1 auto" }}>
                  <Textarea
                    maxRows={10}
                    placeholder="Nhập đánh giá"
                    maxLength={10000}
                    minRows={5}
                    value={dataChamDiem?.ykiendanhgia || ""}
                    onChange={handleChangeYKien}
                    style={{
                      overflowY: "scroll",
                    }}
                    readOnly={status == 2 ? true : false}
                  />
                </Box>
              </Grid>
              <Grid
                item
                xs={12}
                sx={{
                  paddingTop: "0.5rem",
                  borderTop: "1px solid #d6d6d6",
                }}
              >
                <Typography sx={{ textAlign: "center" }}>
                  Tệp đính kèm
                </Typography>
                {status == 2 ? (
                  <>
                    {dataChamDiem?.tepdinhkem &&
                    dataChamDiem?.tepdinhkem?.length > 0 ? (
                      <Grid container p="0 1rem 1rem 1rem">
                        <Grid
                          container
                          style={{
                            color: "#000000",
                            backgroundColor: "#c6e3fa",
                          }}
                          fontSize={"1rem"}
                          fontWeight={600}
                          pb={"0.5rem"}
                          m={"0.5rem 0"}
                          spacing={1}
                          borderBottom={"2px solid #3F51B5"}
                        >
                          <Grid item xs={2}>
                            STT
                          </Grid>
                          <Grid item xs={8}>
                            Tên tệp đính kèm
                          </Grid>
                          <Grid item xs={2}>
                            Tải về
                          </Grid>
                        </Grid>
                        {dataChamDiem?.tepdinhkem?.map((tep, index) => (
                          <Grid
                            container
                            key={tep?.id + index + "tepdinhkem"}
                            style={{ color: "#000000" }}
                            fontSize={"1rem"}
                            borderBottom={"1px solid #d6d6d6"}
                            pb={"0.5rem"}
                            mb={"0.5rem"}
                            ml={0}
                            spacing={1}
                          >
                            <Grid item xs={2}>
                              {index + 1}
                            </Grid>
                            <Grid item xs={8}>
                              {tep?.tentepdinhkem}
                            </Grid>
                            <Grid
                              item
                              xs={2}
                              display={"flex"}
                              alignItems={"center"}
                              justifyContent={"center"}
                              style={{ paddingTop: "0px" }}
                            >
                              <Typography variant="h5" color="info">
                                <Link
                                  target="_blank"
                                  href={
                                    API_URL_DOWNLOAD +
                                    checkUrlTep(tep?.tepdinhkem)
                                  }
                                >
                                  <DownloadIcon />
                                </Link>
                              </Typography>
                            </Grid>
                          </Grid>
                        ))}
                      </Grid>
                    ) : (
                      <Grid
                        container
                        style={{
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                        p="1rem"
                        height="100%"
                      >
                        <Typography
                          style={{
                            fontSize: "1.25rem",
                            fontWeight: "500",
                            lineHeight: "1.5rem",
                            color: "black",
                          }}
                        >
                          Không có thông tin Tệp đính kèm
                        </Typography>
                      </Grid>
                    )}
                  </>
                ) : (
                  <AddListFile
                    dataDefault={dataChamDiem?.tepdinhkem}
                    fileDel={fileDel}
                    fileEditName={fileEditName}
                    fileFields={fileFields}
                    errors={errors}
                    onDelete={handleOnDeleteFileDefault}
                    onError={handleErrorFile}
                    onFileChange={handleChangeFileList}
                    nameFile="phieuchamdiem"
                    onEditName={handleEditFileNameDefault}
                    onErrorDownload={handleErrorDownloadFile}
                    noMedia={true}
                  />
                )}
              </Grid>
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                }}
              >
                <Button onClick={handleReset} color="inherit">
                  Trở về
                </Button>
              </Box>
            </Grid>
          ) : (
            <>
              {steps && steps.length > 0 && (
                <MDBox
                  sx={{
                    backgroundColor: "#fff",
                    borderRadius: "0.5rem",
                    padding: "0.75rem 1.5rem",
                  }}
                  mt={2}
                >
                  <Stepper
                    alternativeLabel
                    activeStep={activeStep?.[tab] || 0}
                    connector={<ColorlibConnector />}
                  >
                    {steps.map((label, index) => (
                      <Step
                        key={label?.id + "tieude"}
                        onClick={handleStepClick(index)}
                        sx={{
                          cursor: "pointer",
                          ".Mui-disabled": { cursor: "pointer !important" },
                        }}
                      >
                        <StepLabel
                          StepIconComponent={ColorlibStepIcon(label?.id)}
                        >
                          {`${label?.ten} (${label?.diem || 0} điểm)`}
                        </StepLabel>
                      </Step>
                    ))}
                  </Stepper>
                  <Fragment>
                    {listNhomTieuChi && listNhomTieuChi.length > 0 ? (
                      <MDBox
                        sx={{
                          backgroundColor: "#fff",
                          borderRadius: "0.5rem",
                        }}
                        mt={2}
                      >
                        <div id="q_question" className="flex min-h-[260px]">
                          <div
                            id="q_contentQuestion"
                            className="flex flex-1 flex-col gap-1"
                          >
                            <h5
                              id="q_count"
                              className="text-sm text-gray-600 italic"
                            >
                              Câu {pageQuestion[tab]?.[activeStep[tab]]} trong
                              tổng {listNhomTieuChi?.length || 0}
                            </h5>
                            <p id="q_question" className="text-base font-bold">
                              {nhomBoTieuChi?.ten}
                            </p>
                            <ol className="mt-1 flex flex-wrap gap-x-7 gap-y-3">
                              {nhomBoTieuChi?.botieuchi?.length > 0 &&
                                nhomBoTieuChi?.botieuchi?.map((item) => {
                                  return (
                                    <li
                                      className={`${
                                        dataChamDiem?.botieuchi?.[item?.id]
                                          ?.id && "bg-gray-200"
                                      } w-full rounded-md border px-4 py-2 shadow-sm shadow-gray-300 text-base cursor-pointer hover:bg-gray-200 ${
                                        status == 2 &&
                                        "pointer-events-none cursor-text"
                                      }`}
                                      key={item?.id + "tieuchi"}
                                      onClick={handleToClickTieuChi(
                                        item,
                                        nhomBoTieuChi?.id
                                      )}
                                    >
                                      <span className="mr-4">
                                        +{item?.diem} điểm
                                      </span>
                                      <span
                                        className={"font-semibold cursor-text"}
                                      >
                                        {item?.ten}
                                      </span>
                                    </li>
                                  );
                                })}
                            </ol>
                          </div>
                        </div>
                        <div className="mt-2 mx-auto flex justify-center">
                          <Pagination
                            count={listNhomTieuChi?.length || 1}
                            color="standard"
                            page={pageQuestion[tab]?.[activeStep[tab]] || 0}
                            onChange={handleChangePage}
                          />
                        </div>
                      </MDBox>
                    ) : (
                      <div className="px-4 my-10 w-full text-center min-h-[260px]">
                        Đang cập nhập thông tin...
                      </div>
                    )}
                    <Box sx={{ display: "flex", flexDirection: "row" }}>
                      <Button
                        color="inherit"
                        disabled={tab === 0 && activeStep[tab] === 0}
                        onClick={handleBack}
                        sx={{ mr: 1 }}
                        size="small"
                      >
                        Trở về
                      </Button>
                      <Box sx={{ flex: "1 1 auto" }} />
                      <Button onClick={handleNext} size="small">
                        Tiếp theo
                      </Button>
                    </Box>
                  </Fragment>
                </MDBox>
              )}
            </>
          )}
          <MDBox
            sx={{
              width: "100%",
              bgcolor: "background.paper",
              marginTop: "0.5rem",
              borderColor: "divider",
              padding: "0.5rem 1rem",
              borderRadius: "0.5rem",
              display: "flex",
              justifyContent: "space-between",
            }}
            mb={4}
          >
            <Button
              variant="contained"
              sx={{ color: "#ffffff" }}
              startIcon={<SaveIcon />}
              onClick={onClickSave}
              disabled={!!(status == 2)}
            >
              Lưu
            </Button>
            <MDButton
              color="primary"
              variant="contained"
              sx={{ color: "#ffffff" }}
              startIcon={<SendIcon />}
              onClick={onClickSend}
              disabled={!!(status == 2)}
            >
              Gửi đánh giá
            </MDButton>
          </MDBox>
        </>
      )}
      <DialogProgress open={openLoadingDialog} value={valueProgress} />
      <Footer />
    </DashboardLayout>
  );
}
const validateArrayRequired = (arrayValue) => {
  let result = [];
  if (arrayValue) {
    arrayValue.map((value, index) => {
      result.push("");
      if (!value?.length) result[index] = "Tên tệp không được trống";
    });
  }
  return result;
};
const validateFileEditName = (arrayValue) => {
  let result = {};
  if (arrayValue) {
    arrayValue.map((file, index) => {
      result[file?.id] = "";
      if (!file?.tentepdinhkem) result[file?.id] = "Tên tệp không được trống";
    });
  }
  return result;
};

function validateOBJ(cd, dungluong) {
  let result = {
    tentepdinhkem: validateArrayRequired(cd.tentepdinhkem),
    tepdinhkemValidate: validateArrayFileRequired(
      cd.tepdinhkemValidate,
      dungluong
    ),
    tentepdinhkemEdit: validateFileEditName(cd.tentepdinhkemEdit),
  };
  return result;
}
export default FormChamDiemCapTinh;
